export function tryParseJSON<T = any>(jsonText: string | undefined | null, defaultValue: T): T
{
    if (typeof jsonText !== "string")
    {
        return defaultValue;
    }

    try
    {
        return JSON.parse(jsonText);
    }
    catch
    {
        return defaultValue;
    }
}